import PurchasePage from '@/pages/purchase/ticket-detail.vue';

export const purchaseRoutes = [
  {
    path: '/purchase/ticket-detail/:boardId/:id',
    component: PurchasePage,
    meta: {
      layout: 'purchase',
    },
  },
];
